import { INSTANCE as DeviceManager } from '@core/devices/DeviceManager'
import { INSTANCE as dataSyncManager } from '@core/databus/DataSyncManager'
import InfoPushClient from '@core/devices/InfoPushClient'
import { INSTANCE as UserInfoManager } from '@core/userInfo/UserInfoManager'
import { INSTANCE as menuManager } from '@core/menus/MenuManager'
import loginManager from '@core/LoginManager'

let infoPushClient: InfoPushClient

class ModuleManager {
  init() {
    this.start()
    loginManager.getInstance().addListener({
      onLogout: () => {
        this.reset()
      },
    })
  }

  async start() {
    //#region DeviceManager ------------ begin ----------------------
    DeviceManager.initDeviceList()
    //#endregion DeviceManager ------------  end  ----------------------

    //#region dataSyncManager ------------ begin ----------------------
    dataSyncManager.init()
    //#endregion dataSyncManager ------------  end  ----------------------

    //#region InfoPushClient ------------ begin ----------------------
    infoPushClient = new InfoPushClient()

    //#endregion InfoPushClient ------------  end  ----------------------
  }

  reset() {
    //#region DeviceManager ------------ begin ----------------------
    DeviceManager.clear()
    //#endregion DeviceManager ------------  end  ----------------------

    //#region dataSyncManager ------------ begin ----------------------
    dataSyncManager.destroy()
    //#endregion dataSyncManager ------------  end  ----------------------

    //#region InfoPushClient ------------ begin ----------------------
    // infoPushClient?.close()
    //#endregion InfoPushClient ------------  end  ----------------------

    //#region UserInfoManager ------------ begin ----------------------
    UserInfoManager.clear()
    //#endregion UserInfoManager ------------  end  ----------------------

    //#region MenuManager ------------ begin ----------------------
    menuManager.destroy()
    //#endregion MenuManager ------------  end  ----------------------
  }
}

const INSTANCE = new ModuleManager()

export { INSTANCE }
